import { render, staticRenderFns } from "./EditarTextoContrato.vue?vue&type=template&id=529a5fcc&scoped=true"
import script from "./EditarTextoContrato.vue?vue&type=script&lang=js"
export * from "./EditarTextoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a5fcc",
  null
  
)

export default component.exports